import powerSvg from '../../dist/ionicons/svg/power.svg';
export default /*#__PURE__*/ powerSvg;
